<script>
export default {
    methods: {
        columnClass(item) {
            if(item !== ''){
                if(item !== this.$root.currentShownItem){
                    return 'hasAction not-active';
                }else{
                    return 'hasAction active';
                }
            }
        },
        showItem(item) {
            this.$emit('show-item', item);
        },
        scrollTo(item) {
            this.$emit('scroll-to', item);
        }
    },
};
</script>

<style lang="scss" scoped>
.three-cols{
    .three-cols-col{
        cursor: pointer;
        transition: all 0.5s;
    }
}
</style>
